<template>
  <div>
    <el-row>
      <el-col style="margin-top: 20px">
        <el-button size="medium" @click="openAdd" v-show="produceStatus == 1 || produceStatus == 2">添加产品</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" border stripe style="margin-top: 20px">
          <el-table-column type="index" label="序号" width="50"></el-table-column>
          <el-table-column prop="PRODUCT_CODE" label="产品编号"></el-table-column>
          <el-table-column prop="NAME" label="产品名称"></el-table-column>
          <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="计划生产总数" v-if="titleData.STATUS == 1">
            <template slot-scope="scope">
              <el-input v-model="scope.row.PRODUCT_COUNT"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="PRODUCT_COUNT" label="计划生产总数" v-else></el-table-column>
          <el-table-column prop="REAL_COUNT" label="实际生产数量">
            <template slot-scope="scope">
              <el-input v-model="scope.row.REAL_COUNT" @input.native="change($event, scope.row)"
                oninput="value=value.replace(/[^0-9.]/g,'')" v-if="titleData.STATUS == 3"></el-input>
              <span v-else>{{ scope.row.REAL_COUNT }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="操作" v-if="titleData.STATUS == 4">
                        <template slot-scope="scope">
                            <el-button @click="editRealCount(scope.row)" type="text" v-show="titleData.STATUS == 4">修改生产数量</el-button>
                        </template>
                    </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="margin-top: 20px">
        <!-- <el-button v-show="titleData.STATUS == 2" @click="readyProduce">开始生产</el-button> -->
        <el-button v-show="titleData.PO_STATUS == 0 && titleData.STATUS !== 1" @click="startProduce">转换采购</el-button>
        <el-button v-show="titleData.STATUS == 3" @click="overProduce">生产完成</el-button>
        <!-- <el-button v-show="titleData.STATUS == 4" @click="enterStock">确认入库</el-button> -->
        <el-button @click="submitProduceDoc" v-show="titleData.STATUS == 1">开始生产</el-button>
      </el-col>
    </el-row>
    <el-dialog title="修改需求总数" center :visible.sync="editFormVisible" width="400px">
      <el-form :model="editForm" ref="editForm">
        <el-form-item label="需求总数：" :label-width="formLabelWidth">
          <el-input v-model="editForm.PRODUCT_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button @click="submitEdit">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改生产数量" center :visible.sync="editRealFormVisible" width="400px">
      <el-form :model="editRealForm" ref="editRealForm">
        <el-form-item label="生产数量：" :label-width="formLabelWidth">
          <el-input v-model="editRealForm.REAL_COUNT"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeEditReal">取 消</el-button>
        <el-button @click="submitEditReal">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="选择采购送货日期" center :visible.sync="orderFormVisible" width="400px">
      <el-form :model="orderForm" ref="orderForm">
        <el-form-item label="送货日期：" :label-width="formLabelWidth">
          <el-date-picker v-model="orderForm.date" type="date" placeholder="选择日期" :clearable="false"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeOrder">取 消</el-button>
        <el-button @click="submitOrder">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :title="infoTitle" center :visible.sync="infoFormVisible" width="600px">
      <el-table :data="infoData" stripe border>
        <el-table-column label="序号" type="index"></el-table-column>
        <el-table-column label="产品编码" prop="PRODUCT_CODE"></el-table-column>
        <el-table-column label="产品名称" prop="NAME"></el-table-column>
        <el-table-column label="单位" prop="TYPE_UNIT"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="infoFormVisible = false">取 消</el-button>
        <el-button @click="goSetting">前往设置</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      tableData: [],
      editForm: {},
      editFormVisible: false,
      formLabelWidth: '100px',
      produceStatus: sessionStorage.getItem('produceStatus'),
      editRealFormVisible: false,
      editRealForm: {},
      produceDay: sessionStorage.getItem('produceDay'),
      orderFormVisible: false,
      orderForm: {},
      infoTitle: '',
      infoFormVisible: false,
      infoData: [],
      transferFalg: 0,
      poStatus: sessionStorage.getItem('poStatus'),
      titleData: {},
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    queryTable() {
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 3,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_DAY: sessionStorage.getItem('produceDate'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
      };
      http.post(params).then((result) => {
        if (result.length == 0) {
          this.tableData = [];
        } else {
          this.tableData = result[0].DETAIL.map((item) => Object.assign(item, { PRODUCE_DAY: this.produceDay }, { EXPIRATION_DAY: 7 }));
          this.titleData = result[0].TITLE[0];
        }
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    change(e, row) {
      row.REAL_COUNT = e.target.value;
    },
    editTotalCount(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    submitEdit() {
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 4,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: this.titleData.ID,
        DETAIL_ID: this.editForm.ID,
        PRODUCT_COUNT: this.editForm.PRODUCT_COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '修改成功',
          type: 'success',
        });
        this.editFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    close() {
      this.editFormVisible = false;
    },
    startProduce() {
      this.orderFormVisible = true;
    },
    // 转换采购、开始生产
    submitOrder() {
      if (!this.orderForm.date) {
        this.$message.show({ text: '请选择收货日期', type: 'warning' });
        return false;
      }
      this.$router.push({ name: 'transferShop' });
      sessionStorage.setItem('transferDate', this.orderForm.date);
      sessionStorage.setItem('produceId', this.titleData.ID);
      // let params = {
      //     SERVICE_ID:"12002",
      //     OTYPE: 9,
      //     USER_ID:sessionStorage.getItem("userId"),
      //     SESSION:sessionStorage.getItem("session"),
      //     ORDER_ID: sessionStorage.getItem('produceId'),
      //     SEND_DAY: this.orderForm.date,
      //     SUPPLIER_ID: Number(sessionStorage.getItem("tcId"))
      // }
      // http.post(params).then(result => {
      //     this.transferFalg = result[0].FLAG
      //     if (result[0].FLAG == 1){
      //         this.infoFormVisible = true
      //         this.infoData = result[0].DATA
      //         this.infoTitle = '以下产品未设置配料表，请设置配料后转换'
      //         this.$message.show({
      //             text:'转换失败',
      //             type: 'error'
      //         });
      //     } else if(result[0].FLAG == 2){
      //         this.infoFormVisible = true
      //         this.infoData = result[0].DATA
      //         this.infoTitle = '以下原料未设置采购价，请设置后转换'
      //         this.$message.show({
      //             text:'转换失败',
      //             type: 'error'
      //         });
      //     }else{
      //         this.$message.show({
      //             text: '操作成功',
      //             type: 'success'
      //         });
      //         this.$router.push({name: 'orderToProduce'})
      //     }
      // }).catch(error => {
      //     this.$message.show({
      //         text:error,
      //         type: 'error'
      //     });
      // })
    },
    goSetting() {
      if (this.transferFalg == 1) {
        this.$router.push({ name: 'productionSet' });
      } else if (this.transferFalg == 2) {
        this.$router.push({ name: 'supplierManage' });
      } else {
        return false;
      }
    },
    closeOrder() {
      this.orderFormVisible = false;
    },
    // 生产完成
    overProduce() {
      const flag = this.tableData.find((item) => {
        if (!item.REAL_COUNT) {
          return true;
        }
      });
      if (flag) {
        this.$message.show({ text: '请输入实际生产数量', type: 'warning' });
        return false;
      }
      let tmpArr = [];
      tmpArr = this.tableData.map((item) => ({ DETAIL_ID: item.ID, REAL_COUNT: item.REAL_COUNT }));
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 6,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: this.titleData.ID,
        PRODUCT_ARRAY: tmpArr,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '操作成功',
          type: 'success',
        });
        this.$router.push({ name: 'sellProductsDetail' });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 生产完成修改实收数量
    editRealCount(row) {
      this.editRealFormVisible = true;
      this.editRealForm = row;
    },
    submitEditReal() {
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 5,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: this.titleData.ID,
        DETAIL_ID: this.editRealForm.ID,
        REAL_COUNT: this.editRealForm.REAL_COUNT,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '修改成功',
          type: 'success',
        });
        this.editRealFormVisible = false;
        this.queryTable();
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    closeEditReal() {
      this.editRealFormVisible = false;
    },
    // enterStock() {
    //   let tmpStockArr = [];
    //   tmpStockArr = this.tableData.map((item) => ({ ORDER_DETAIL_ID: item.ID, PRODUCTION_DATE: item.PRODUCE_DAY, EXPIRATION_DAY: Number(item.EXPIRATION_DAY) }));
    //   const params = {
    //     SERVICE_ID: '12002',
    //     OTYPE: 8,
    //     USER_ID: sessionStorage.getItem('userId'),
    //     SESSION: sessionStorage.getItem('session'),
    //     SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
    //     ORDER_ID: this.titleData.ID,
    //     PRODUCT_ARRAY: tmpStockArr,
    //   };
    //   http.post(params).then((result) => {
    //     this.$message.show({
    //       text: '操作成功',
    //       type: 'success',
    //     });
    //     this.$router.push({ name: 'sellProductsDetail' });
    //   }).catch((error) => {
    //     this.$message.show({
    //       text: error,
    //       type: 'error',
    //     });
    //   });
    // },
    openAdd() {
      this.$router.push({ name: 'addProProduct' });
    },
    submitProduceDoc() {
      let produceArray = [];
      produceArray = this.tableData.map((item) => ({ DETAIL_ID: item.ID, NEED_COUNT: item.PRODUCT_COUNT }));
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 12,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        ORDER_ID: this.titleData.ID,
        PRODUCT_ARRAY: produceArray,
      };
      http.post(params).then((result) => {
        this.readyProduce();
        // this.$message.show({
        //     text: '操作成功',
        //     type: 'success'
        // });
        // this.queryTable()
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    // 开始生产
    readyProduce() {
      const params = {
        SERVICE_ID: '12002',
        OTYPE: 7,
        USER_ID: sessionStorage.getItem('userId'),
        SESSION: sessionStorage.getItem('session'),
        ORDER_ID: this.titleData.ID,
      };
      http.post(params).then((result) => {
        this.$message.show({
          text: '操作成功',
          type: 'success',
        });
        // this.queryTable()
        this.$router.push({ name: 'sellProductsDetail' });
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/productionProcessing/produceDetail.vue